"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rivanazzano-terme": {
    "ab42dbe6": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "buscofa": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72b4f5c0": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "cascinetta-spalla": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "abeccb8e": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "chioda": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7d227b7": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "nazzano": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3845e2aa": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "salice": [{
      "hkey": "a12c8801",
      "slug": "rivanazzano-terme",
      "name": "Rivanazzano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;